module.exports = __webpack_public_path__ + "img/hummus.3d47ea4b.jpg";